import { Component, Input, computed, signal } from '@angular/core';
import { CallToActionWidget, Theme } from '../../models/reader-document';

@Component({
  selector: 'wr-call-to-action-widget',
  standalone: true,
  template: `
    <div class="section-callToAction">
      <div class="container-login">

        <!-- Image -->
        @if (imageSrc()) {
          <img
            [src]="imageSrc()!"
            [alt]="altText()"
            class="w-full"
            (error)="onImgError($event)"
          />
        }

        <!-- Social icons -->

        @if (widget()?.socialNetworks?.length) {
          <div class="btnSocialNet px-4" [style.inset-inline-end]="widget()?.iconAlignment === undefined ? '12px' : (widget()?.iconAlignment === 'right' ? '12px' : null)" [style.inset-inline-start]="widget()?.iconAlignment === 'left' ? '12px' : null" [style.justify-self]="widget()?.iconAlignment === 'center' ? 'center' : null" >
            @for (sn of widget()?.socialNetworks ?? []; track sn.url) {
              <a
                [href]="sn.url"
                target="_blank"
                class="inline-flex"
              >
                <span
                  class="w-7 h-7 hover:opacity-80 duration-400 ease-in-out"
                  [style.background-color]="accentColor()"
                  [style.mask]="'url(assets/icons/' + sn.type + '.svg) no-repeat center / contain'"
                  [style.webkitMask]="'url(assets/icons/' + sn.type + '.svg) no-repeat center / contain'"
                ></span>
              </a>

            }
          </div>
        }

      </div>
    </div>
  `,
})
export class CallToActionWidgetComponent {
  private widgetSig = signal<CallToActionWidget | null>(null);
  private themeSig = signal<Theme & { isDark?: boolean } | null>(null);
  private imgSrcSig = signal<string | null>(null);

  @Input() set json(value: CallToActionWidget) {
    this.widgetSig.set(value);

    const primary = value?.imageUrl || null;
    const fallback = value?.fallbackUrl || null;
    this.imgSrcSig.set(primary || fallback);
  }

  @Input() set theme(value: Theme | undefined) {
    this.themeSig.set(value ?? null);
  }

  accentColor = computed(() => {
    const theme = this.themeSig();
    if (!theme) return '#ff5e38';

    return theme.isDark
      ? theme.darkColors.accent ?? '#ff5e38'
      : theme.lightColors.accent ?? '#ff5e38';
  });

  widget = computed(() => this.widgetSig());

  imageSrc = computed(() => this.imgSrcSig());

  altText = computed(
    () =>
      this.widget()?.altTitle ??
      this.widget()?.name ??
      this.widget()?.id ??
      'call to action'
  );

  onImgError(_: Event) {
    const w = this.widget();
    if (!w?.fallbackUrl) return;

    if (this.imgSrcSig() !== w.fallbackUrl) {
      this.imgSrcSig.set(w.fallbackUrl);
    }
  }
}
